(function () {
	'use strict';
	var $ = window.jQuery;

	function Event19for19(options) {
		if (!options) {
			throw new Error('No options passed to Event19for19 constructor');
		}

		this.options = $.extend({}, Event19for19.defaults, options);

		if ($('.page_19for19').length) {
			this.initSideNav();
			this.initStickyHeader();
			this.initMobileHeaderNav();
			this.initAnchorLinks();
		}
	}

	Event19for19.prototype.initSideNav = function () {
		var $sideNavSelector = $('.side-nav'),
			$sectionSelector = $('.section');

		if ($sideNavSelector.length) {
			$sectionSelector.each(function() {
				$(this).waypoint(function(direction) {
					var index = $(this.element).attr('data-index');

					$sideNavSelector.find('a').removeClass('active');
					if (direction === 'down') {
						$sideNavSelector.find('a[data-index="' + index + '"]').addClass('active');
					} else {
						$sideNavSelector.find('a[data-index="' + (index - 1) + '"]').addClass('active');
					}

					/*$(this.element).find('.step__hero').waypoint(function(direction) {
						$sideNavSelector.find('a span').removeClass('white');
						if (direction === 'down') {
							$sideNavSelector.find('a[data-index="' + index + '"] span').addClass('white');
						} else {
							$sideNavSelector.find('a[data-index="' + (index - 1) + '"] span').addClass('white');
						}
					});*/
				});
			});
		}
	};

	Event19for19.prototype.initStickyHeader = function () {
		var $headerSelector = $(this.options.headerContainer);

		if ($headerSelector.length) {
			// Sticky Header
			new window.Waypoint.Sticky({
				element: $headerSelector[0],
				stuckClass: 'fixed',
			});
		}
	};

	Event19for19.prototype.initMobileHeaderNav = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb');

		$mobileHamburger.click(function (e) {
			e.preventDefault();

			if ($headerNavSelector.hasClass('opened')) {
				$headerNavSelector.find('ul').slideDown(300);
			} else {
				$headerNavSelector.find('ul').slideUp(300);
			}
		});

		$(window).resize(function () {
			$mobileHamburger.removeClass('open');
			$bodySelector.removeClass('mobile-menu-opened');
			$headerNavSelector.removeClass('opened');
			$('li.has-dropdown > a').removeClass('active');
		});
	};

	Event19for19.prototype.initAnchorLinks = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb'),
			$sideNavSelector = $('.side-nav');

		$('a[href*="#"]:not([href="#"])').click(function() {
			if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
				var target = $(this.hash),
					offset = 38;
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
					$sideNavSelector.find('a').removeClass('active');
					$('html, body').animate({
						scrollTop: target.offset().top - offset,
					}, 1000);

					$mobileHamburger.removeClass('open');
					$bodySelector.removeClass('mobile-menu-opened');
					$headerNavSelector.removeClass('opened');
					$('li.has-dropdown > a').removeClass('active');
					return false;
				}
			}
		});
	};

	Event19for19.defaults = {
		headerNavSelector: '.page_19for19 .header__nav',
		headerContainer: '.page_19for19 .header',
	};

	window.Event19for19 = Event19for19;
}());
